import axios from "axios";

const appauth_key = "www.swagstay.com";
let APL_LINK = "https://www.nsirl.com/";

// by sumit chourey
const save_form_by_email = APL_LINK + "sendgrid/save_form_by_email.php";

const server_post_data = async (url_for, Data) => {
  try {
    if (Data === null) {
      Data = new FormData();
    }
    const response = await axios.post(url_for, Data, {
      headers: {
        "Content-Type": "multipart/form-data", // If sending FormData
        // Include other headers as needed for your backend
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export { APL_LINK, appauth_key, server_post_data, save_form_by_email };
